import { Tabs } from 'antd'
import { YhBox } from '@/components/YhBox'
import { PageHeader } from './PageHeader'
import { DataBox1 } from './DataBox1';
import { DataBox2 } from './DataBox2';
import { totalModel } from './totalModel'

export function SupplierBillSettle() {

    const { tabs, setTabs } = totalModel();

    return (
        <>
            <YhBox title="" style={{ padding: 10 }}>
                <PageHeader />
                <Tabs defaultActiveKey={tabs} size={"large"} onChange={(e) => { setTabs(e) }}>
                    <Tabs.TabPane tab="待核销" key="1">
                        <DataBox1 />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="已核销" key="2">
                        <DataBox2 />
                    </Tabs.TabPane>
                </Tabs>
            </YhBox>
        </>
    )
}
